/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "CreditCardClientDrivenFlow": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "AUTOPAY_SETTINGS": 1,
                      "CARD_ACTIVATION": 2
                    }
                  },
                  "CreditCardReviewCreditLimitFlow": {
                    "fields": {
                      "creditLineId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "creditLimitChangeId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreditCardAutopaySettings": {
                    "fields": {
                      "creditLineId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreditCardActivation": {
                    "fields": {
                      "creditLineId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardClientDrivenFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardReviewCreditLimitFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardAutopaySettings && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardActivation) {
  $root.addJSON(jsonData);
}

/**
 * Discouraged to add new enums to this. Instead please add one-off messages.
 * One-off messages per feature allow us to pass metadata to the client.
 *
 * SOURCE CreditCardClientDrivenFlow @ squareup/bbfrontend/v1/credit_card_client_driven_flow.proto at 13:1
 */
export const CreditCardClientDrivenFlow = $root.lookupEnum('squareup.bbfrontend.service.v1.CreditCardClientDrivenFlow').values;
/**
 * SOURCE CreditCardReviewCreditLimitFlow @ squareup/bbfrontend/v1/credit_card_client_driven_flow.proto at 19:1
 */
export const CreditCardReviewCreditLimitFlow = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardReviewCreditLimitFlow');
fixType(CreditCardReviewCreditLimitFlow, {
  creditLineId: {
    notEmpty: true
  },
  creditLimitChangeId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreditCardReviewCreditLimitFlow);
/**
 * SOURCE CreditCardAutopaySettings @ squareup/bbfrontend/v1/credit_card_client_driven_flow.proto at 24:1
 */
export const CreditCardAutopaySettings = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardAutopaySettings');
fixType(CreditCardAutopaySettings, {
  creditLineId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreditCardAutopaySettings);
/**
 * SOURCE CreditCardActivation @ squareup/bbfrontend/v1/credit_card_client_driven_flow.proto at 28:1
 */
export const CreditCardActivation = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardActivation');
fixType(CreditCardActivation, {
  creditLineId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreditCardActivation);